// extracted by mini-css-extract-plugin
module.exports = {"pic_box":"pic_box-1mVkBO66"};